import { SchoolSidebar } from "../components/ui/school/school-dashboard/school-sidebar"
import ClassDetailHeader from "../components/ui/school/class-overview/class-detail-header"
import { ClassStatsCards } from "../components/ui/school/class-overview/class-stats-cards"
import { StudentsTable } from "../components/ui/school/class-overview/students-data"
import { SubjectsTabSection } from "../components/ui/school/class-overview/subjects-tab-section"
import { ss2StudentsData, ss2SubjectsData } from "../lib/class-students-data"
import { useState } from "react"

const ClassOverviewPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  // Demo data for SSS2
  const classData = {
    className: "SSS2",
    classTeacher: "Mrs. Aisha Bello",
    studentCount: 28,
    classAverage: 76,
    topPerformer: "Chisom Okafor",
    subjectsTaken: 12,
  }

  return (
    <div className="flex min-h-screen bg-slate-50">
      {/* Sidebar */}
      <SchoolSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} activePage="class-overview" />

      {/* Overlay for mobile */}
      {isSidebarOpen && (
        <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setIsSidebarOpen(false)} />
      )}

      {/* Main Content */}
      <div className="flex-1 lg:ml-64">
        <main className="max-w-7xl mx-auto px-6 py-8">
          <ClassDetailHeader
            className={classData.className}
            classTeacher={classData.classTeacher}
            studentCount={classData.studentCount}
          />

          <ClassStatsCards
            classAverage={classData.classAverage}
            topPerformer={classData.topPerformer}
            subjectsTaken={classData.subjectsTaken}
          />

          <StudentsTable students={ss2StudentsData} />

          <SubjectsTabSection subjects={ss2SubjectsData} />
        </main>
      </div>
    </div>
  )
}

export default ClassOverviewPage